import { Routes } from '@angular/router';

import { HankoAuthGuard } from '@app/security/feature/hanko/data-access/hanko-auth.guard';

import { RedirectGuard } from '@shared/data-access/guards/redirect.guard';
import { Error401Component } from '@shared/ui/errors/error401.component';
import { Error403Component } from '@shared/ui/errors/error403.component';
import { Error404Component } from '@shared/ui/errors/error404.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'redirect' },

  {
    path: 'auth',
    loadChildren: () => import('@app/security/shell/auth.routes').then((m) => m.authRoutes),
  },

  {
    path: 'errors',
    children: [
      { path: '401', component: Error401Component, title: 'Sesja wygasła — CAPD' },
      { path: '403', component: Error403Component, title: 'Brak dostępu — CAPD' },
      { path: '404', component: Error404Component, title: 'Strona nie istnieje — CAPD' },
    ],
  },

  {
    path: 'redirect',
    pathMatch: 'full',
    children: [],
    canActivate: [RedirectGuard],
  },

  {
    path: '',
    canActivate: [HankoAuthGuard],
    loadComponent: () => import('@app/shell/main-shell.component').then((m) => m.MainShellComponent),
    children: [
      {
        path: 'patients',
        loadChildren: () => import('@app/patients/patients.routes').then((m) => m.PATIENTS_ROUTES),
      },
      {
        path: 'therapists',
        loadChildren: () => import('@app/therapists/therapists.routes').then((m) => m.THERAPISTS_ROUTES),
      },
      {
        path: 'facilities',
        loadChildren: () => import('@app/facilities/facilities.routes').then((m) => m.FACILITIES_ROUTES),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('@app/shared/features/settings/settings.component').then((m) => m.SettingsComponent),
      },
    ],
  },

  { path: '**', redirectTo: 'errors/404' },
];
